<template>
  <v-col cols=12 class="pa-0 ma-0">
      <router-view :key="$route.params.id_station || null"/>
  </v-col>
</template>

<script>
export default {
  mounted()
  {
    if(this.$route.query.id_station)
    {
      this.$router.push(`/stations/${this.$route.query.id_station.split('pm_')[1]}`)
    }
  }
}
</script>

<style>

</style>